import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
// const TIPO_ACTO = 's1';
const URL_BASE_ACTOS = `${API_URL}/acto`
const GET_PRESENTADAS = `${API_URL}/acto`;
const BORRADOR_SOLICITUD = `${API_URL}/acto`;
const PRESENTAR_SOLICITUD = `${API_URL}/acto`;
const GET_BORRADOR = `${API_URL}/acto`;
const UPDATE_BORRADOR = `${API_URL}/acto`;
const DELETE_BORRADOR = `${API_URL}/acto`;
const GET_BORRADORES = `${API_URL}/acto`;
const VALIDA_ALTA = `${API_URL}/acto`;
const OBTENER_SOLICITUD_BORRADOR_PDF = `${API_URL}/acto`;

const VALIDA_PRESENTADA = `${API_URL}/acto`;
const ANULAR_PRESENTADA = `${API_URL}/acto`;
const OBTENER_SOLCITUD_PRESENTADA_PDF = `${API_URL}/acto`;
const OBTENER_DATOS_RESTANTES_DATOSPERPRO = `${API_URL}/acto`;

const NOTIFICA_PRESENTADA = `${API_URL}/acto`;

export async function getDatoBorradores(tipoActo) {
  return await axios({
    method: "GET",
    url: `${GET_BORRADORES}/${tipoActo}/borrador`
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de los borradores")
    );
}
export async function getDatoPresentada(tipoActo) {
  return await axios({
    method: "GET",
    url: `${GET_PRESENTADAS}/${tipoActo}/presentada`
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al recoger los datos de las presentadas")
    );
}
export async function sendBorradorS1(valores) {
  return await axios({
    method: "POST",
    url: `${BORRADOR_SOLICITUD}/s1/borrador`,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al enviar el Borrador")
    );
}

export async function sendBorradorZ9(valores) {
  return await axios({
    method: "POST",
    url: `${BORRADOR_SOLICITUD}/z9/borrador`,
    data: valores,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al enviar el Borrador")
    );
}

export async function presentarSolicitud(id, tipoActo, pdfBlob) {
  const formData = new FormData();
  formData.append('pdf', pdfBlob); // Agregar el Blob al FormData
  return await axios({
    method: "POST",
    url: `${PRESENTAR_SOLICITUD}/${tipoActo}/borrador/${id}/presentar`,
    data: formData, // Enviar el FormData
    headers: {
      'Content-Type': 'multipart/form-data', // Asegúrate de establecer el tipo de contenido
    },
  })
    .then((response) => response.data)
    .catch((error) => {
      // // console.error("Error: Fallo al presentar solicitud", error);
      return "Error: Fallo al presentar solicitud";
    });
}
/*export async function createBorrador(valores) {
  return await axios({
    method: "POST",
    url: CREATE_BORRADOR,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al actualizar solicitud"));
}*/
export async function updateBorradorS1(id,valores) {
  return await axios({
    method: "PUT",
    //url: `${UPDATE_BORRADOR}/${id}`,
    url: `${UPDATE_BORRADOR}/s1/borrador/${id}`,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al actualizar borrador"));
}

export async function updateBorradorZ9(id,valores,tipoActo) {
  return await axios({
    method: "PUT",
    //url: `${UPDATE_BORRADOR}/${id}`,
    url: `${UPDATE_BORRADOR}/z9/borrador/${id}`,
    data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al actualizar borrador"));
}
export async function deleteBorrador(id,tipoActo) {
  
  
  return await axios({
    method: "DELETE",
    //url: `${DELETE_BORRADOR}/${id}`,
    // url: `${DELETE_BORRADOR}`.replace("{xsolactadm}",`${id}`),
    // ${API_URL}/acto/${TIPO_ACTO}/borrador/{xsolactadm}
    url: `${DELETE_BORRADOR}/${tipoActo}/borrador/${id}`,
    // data: valores,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al BORRAR borrador"));
}
export async function validarAlta(id,tipoActo) {

  return await axios({
    method: "POST",
    //url: `${VALIDA_ALTA}/${id}`.replace("{xsolactadm}", "123456"),
    url: `${VALIDA_ALTA}/${tipoActo}/borrador/${id}/validar`,
    // headers: {
    //   Authorization: "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken,
    // }

  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al validar el alta"));
}
export async function validarPresentada(id,tipoActo) {
  return await axios({
    method: "POST",
    url: `${VALIDA_PRESENTADA}/${tipoActo}/presentada/${id}/validar`
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo al validar la presentación"));
}

// export async function getPDFActoPresentado(id,tipo) {
//   // 
//   // enviar parametros como dni por e.j. para realizar la query en el back

//   return await axios({
//     method: "GET",
//     url: `${GET_PDF_A1A2}/${id}/${tipo}`,
//     responseType: "blob",
//     //   params: { dni: dni },
//   })
//     .then((response) => response.data)
//     .catch((response) => (response.data = "Error:"));
// }

//datosPersona ??
export async function getSolicitud(id,tipoActo) {
  return await axios({
    method: "GET",
    //url: `${GET_BORRADOR}/${id}`,
    url: `${GET_BORRADOR}/${tipoActo}/borrador/${id}/datosPersona`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger el Borrador")
    );
}

export async function obtenerBorrador(id,tipoActo) {
  return await axios({
    method: "GET",
    //url: `${GET_BORRADOR}/${id}`,
    url: `${GET_BORRADOR}/${tipoActo}/borrador/${id}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo al recoger el Borrador")
    );
}

export async function getSolicitudPDF(id,tipoActo) {
  return await axios({
    method: "GET",
    //url: `${OBTENER_SOLCITUD}/${id}`,
    url: `${OBTENER_SOLICITUD_BORRADOR_PDF}/${tipoActo}/borrador/${id}/pdf`,
    responseType: "blob",
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al obtener la solicitud como PDF")
    );
}
export async function anularPresentada(id,tipoActo) {
  return await axios({
    method: "GET",
    //url: `${ANULAR_PRESENTADA}/${id}`,
    url: `${ANULAR_PRESENTADA}/${tipoActo}/presentada/${id}/anular`,
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al anular la solicitud")
    );
}

export async function getSolicitudPresentadaPDF(id,tipoActo) {
  return await axios({
    method: "GET",
    //url: `${OBTENER_SOLCITUD_PDF_PRESENTADA}/${id}`,
    url: `${OBTENER_SOLCITUD_PRESENTADA_PDF}/${tipoActo}/presentada/${id}/pdf`,
    responseType: "blob",
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al obtener la solicitud como PDF")
    );
}

export async function notificaPresentada(id,tipoActo) {
  return await axios({
    method: "PUT",
    url: `${NOTIFICA_PRESENTADA}/${tipoActo}/presentada/${id}/notificar`
  })
    .then((response) => {
      
      return response.data
    })
    .catch(
      (response) =>
        (response.data = "Error: Fallo al NOTIFICAR la solicitud")
    );
}

export async function getJustificacionActoPresentado(xsolactadm,tipoActo) {
  return await axios({
    method: "GET",
    url: `${URL_BASE_ACTOS}/${tipoActo}/presentada/${xsolactadm}/justificante`,
    responseType:"blob"
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error"));
}


export async function getResolucionActoPresentado(xsolactadm,tipoActo) {
  return await axios({
    method: "GET",
    url: `${URL_BASE_ACTOS}/${tipoActo}/presentada/${xsolactadm}/resolucion`,
    responseType:"blob"
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error"));
}

export async function getDatosPerProRestantes18(xpersona,tipoActo){
  return await axios({
    method:"GET",
    url:`${OBTENER_DATOS_RESTANTES_DATOSPERPRO}/${tipoActo}/datosPer/${xpersona}`
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error"));
}